<template>
  <div class="getcal-container">
    <div v-if="loading" class="getcal-status">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-3 text-muted">Loading calendar...</p>
    </div>
    <div v-else-if="error" class="getcal-status">
      <i class="material-icons text-danger" style="font-size:48px;">error_outline</i>
      <p class="mt-3 text-danger fw-semibold">{{ error }}</p>
    </div>
    <div v-else class="getcal-status">
      <i class="material-icons text-success" style="font-size:48px;">event</i>
      <h5 class="mt-3">Calendar Subscription URL</h5>
      <p class="text-muted" style="max-width:500px;">This URL provides a live iCal feed. Add it to Google Calendar, Outlook, Yahoo, or Apple Calendar to automatically receive schedule updates.</p>
      <div class="input-group mb-3" style="max-width:600px;">
        <input type="text" class="form-control form-control-sm" :value="icalUrl" readonly />
        <button class="btn btn-sm btn-outline-primary" @click="copyUrl">Copy URL</button>
      </div>
      <p class="text-xs text-muted">Redirecting to calendar feed...</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { apiBaseUrl } from '@/utils/BaseUrl.js'

const route = useRoute()
const loading = ref(true)
const error = ref(null)
const icalUrl = ref('')

function copyUrl() {
  navigator.clipboard.writeText(icalUrl.value).catch(() => {})
}

onMounted(() => {
  const encodedId = route.params.encodedId
  const calType = route.params.calType // "person" or "workgroup"

  if (!encodedId || !calType) {
    error.value = 'Invalid calendar URL.'
    loading.value = false
    return
  }

  // Build the direct API iCal URL (serves text/calendar inline for subscription)
  icalUrl.value = `${apiBaseUrl}/calendar/${calType}/${encodedId}/ical`
  loading.value = false

  // Redirect browser to the iCal feed after a short delay
  setTimeout(() => {
    window.location.href = icalUrl.value
  }, 1500)
})
</script>

<style scoped>
.getcal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f8f9fa;
}
.getcal-status {
  text-align: center;
}
</style>
